import React from 'react';
import '../css/NavBar.css';

import '../css/Blog.css';

import data from '../data/articles.json';

// import Link from '../composant/Link';
import Images from '../composant/Images';
import Header from '../composant/Header';

function formatDate(data) {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date(data);
    return date.toLocaleDateString('fr-FR', options);
}

const Blog = (page) => {
    if(data.data == null){return(<></>)}
    return (
        <div>
            <div className='blog'>
                <Header data={{
                    title: page.data[0].titre,
                    favicon: {
                        data: {
                            attributes: {
                                url: 'https://res.cloudinary.com/orchidee/image/upload/v1672523627/Orchidee_White_73d9d285a3.png'
                            }
                        }
                    }
                }}></Header>
                <Images className={"logo"} data={page.data[0].logo}></Images>
                <br></br>
                {
                    data.data.map((val) => {
                        return (
                            <a key={val.id} href={`/blog/${val.attributes.article}`}>
                                <div className='article'>
                                    <p className='publish'>{formatDate(val.attributes.publishedAt)}</p>
                                    <h2>{val.attributes.title}</h2>
                                    <span>{val.attributes.description}</span><br></br>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" class="mt-4">
                                        <path class="stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M12 19l7-7-7-7"></path>
                                    </svg>
                                </div>
                            </a>
                        );
                    })
                }
                {/* <div className='Layout_colorBackground__Adyt4'></div>
                <div className='Layout_colorBackgroundBottom__9Yf_q'></div> */}
            </div>
        </div>
    );
}

export default Blog;
